export const faqs = [
  {
    q: 'Werkt het voor elk niveau?',
    a: 'Ja. Elke sessie heeft versie A voor beginners, versie B voor gevorderden en versie C voor experts. Zo geef je zonder problemen dezelfde les aan een gemengde groep.',
  },
  {
    q: 'Hoeveel betaal ik precies?',
    a: 'Je betaalt eenmalig €19. Je ziet het exacte eindbedrag altijd vóórdat je betaalt — geen verborgen kosten, geen abonnement en geen verrassingen achteraf.',
  },
  {
    q: 'Hoe ontvang ik het materiaal?',
    a: 'Direct toegang binnen 5 minuten. Na je betaling ontvang je een e-mail met je persoonlijke link. Download alle 6 delen als pdf — de bestanden zijn VOOR ALTIJD van jou. Print ze of gebruik ze direct op je telefoon, tablet of computer.',
  },
  {
    q: 'Heb ik speciaal materiaal nodig?',
    a: 'NEE — alleen basismateriaal. De sessies gebruiken halters, dumbbells, kettlebells, plyoboxen, TRX en matten. Heeft je sportschool de basis? Dan BEN JE ER KLAAR VOOR.',
  },
  {
    q: 'Werkt het ook als ik fitnessinstructeur ben en geen gymleraar?',
    a: 'JA — 70% van onze klanten is fitnessinstructeur. Functionele Training 365 is gemaakt voor gymleraren, fitnessinstructeurs, CrossFit-coaches, personal trainers en kracht- en conditietrainers.',
  },
  {
    q: 'Is de garantie echt?',
    a: '100% echt — geen formulieren, geen gedoe. Koop vandaag en ben je binnen 7 dagen niet enthousiast? Stuur ons een e-mail en je krijgt je geld terug. We vragen niet waarom. Minder dan 2% vraagt ooit om terugbetaling.',
  },
  {
    q: 'Ik ben beginner — heb ik kennis van programmeren nodig?',
    a: 'NEE. Je hoeft niets te weten van periodisering of geavanceerde theorie. Elke sessie is AL uitgewerkt met doel, oefeningen en sets. Openen, lezen, lesgeven. Het werkt voor nieuwe én ervaren coaches — 40% van onze klanten is net begonnen als coach.',
  },
  {
    q: 'Kan ik het met meer dan één groep gebruiken?',
    a: 'JA — onbeperkt gebruik met al je groepen. Eén betaling = levenslange toegang. Gebruik het met 1 groep, 5 groepen of 20 groepen. Geen beperkingen.',
  },
]
